import { Card } from "@scuf/common";
import { Chart } from "@scuf/charts";
import React, { useEffect, useState } from "react";
import { getValoresPeriodo } from "../../../services/services";
import formatDate from "../../../utils/formatDate";
import "../TGases.css";
import { plotBackground } from "../../../config/colors";

//TS -> Tostador

export default function SalidaFreeboard() {
  const [flujosSolidosST, setFlujosSolidosST] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [caudalGasST, setCaudalGasST] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [porcentajeN2ST, setPorcentajeN2ST] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [porcentaje02ST, setPorcentaje02ST] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [porcentajeH20ST, setPorcentajeH20ST] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [porcentajeS2ST, setPorcentajeS2ST] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [porcentajeS02ST, setPorcentajeS02ST] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [porcentajeAs2S3ST, setPorcentajeAs2S3ST] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [porcentajeAs4O6ST, setPorcentajeAs4O6ST] = useState({
    value: [],
    fecha: [],
    estado: [],
  });


  // Fecha inicial y final
  const [date, setDate] = useState({ start: "19-01-2023", end: "25-01-2023" });

  // Objeto inicial de la peticion
  const initialFetch = {
    idSeccion: 3,
    secuencia: 34,
    ultimo: 0,
    frecuencia: 5,
    dias: 7,
  };

  useEffect(() => {
    // Peticion de datos al API
    async function fetchData() {
      // Solo nos traemos la data de la peticion
    const { data } = await getValoresPeriodo(initialFetch);
    populateFlujosSolidosST(data);
    populateCaudalGasST(data);
    populatePorcentajen2ST(data);
    populatePorcentaje02ST(data);
    populatePorcentajeH20ST(data);
    populatePorcentajeS2ST(data);
    populatePorcentajeS02ST(data);
    populatePorcentajeAs2S3ST(data);
    populatePorcentajeAs4O6ST(data);
      //#endregion
    }

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function populateFlujosSolidosST(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Flujo de Sólidos Salida Tostador"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setFlujosSolidosST({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateCaudalGasST(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Caudal de Gas Salida Tostador"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setCaudalGasST({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populatePorcentajen2ST(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "%N2 Salida Tostador"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setPorcentajeN2ST({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populatePorcentaje02ST(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "%O2 Salida Tostador"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setPorcentaje02ST({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populatePorcentajeH20ST(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "%H2O Salida Tostador"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setPorcentajeH20ST({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populatePorcentajeS2ST(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "%S2 Salida Tostador"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setPorcentajeS2ST({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populatePorcentajeS02ST(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "%SO2 Salida Tostador"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setPorcentajeS02ST({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populatePorcentajeAs2S3ST(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "%As2S3 Salida Tostador"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setPorcentajeAs2S3ST({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populatePorcentajeAs4O6ST(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "%As4O6 Salida Tostador"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setPorcentajeAs4O6ST({
      fecha: arrFechas,
      value: arrValues,
    });
  }

 
  return (
    <>
       <Card>
        <Card.Content>
          <Chart
            plotBackgroundColor={plotBackground}
            title={"Perfil de Salida Freeboard"}
            subtitle={"Periodo " + date.start + " - " + date.end}
          >
            {/** -------------------------------- Flujo de Sólidos Salida Tostador --------------------------------------- */}
            <Chart.Line
              name="Flujo de Sólidos Salida Tostador"
              data={flujosSolidosST.value}
              yAxis={0}
            />
            {/** -------------------------------- Caudal de Gas Salida Tostador --------------------------------------- */}
            <Chart.Line
              name="Caudal de Gas Salida Tostador"
              data={caudalGasST.value}
              yAxis={0}
            />
            {/** -------------------------------- %N2 Salida Tostador --------------------------------------- */}
            <Chart.Line
              name="%N2 Salida Tostador"
              data={porcentajeN2ST.value}
              yAxis={1}
            />
            {/** -------------------------------- %O2 Salida Tostador --------------------------------------- */}
            <Chart.Line
              name="%O2 Salida Tostador"
              data={porcentaje02ST.value}
              yAxis={1}
            />
            {/** -------------------------------- %H2O Salida Tostador --------------------------------------- */}
            <Chart.Line
              name="%H2O Salida Tostador"
              data={porcentajeH20ST.value}
              yAxis={1}
            />
            {/** -------------------------------- %S2 Salida Tostador --------------------------------------- */}
            <Chart.Line
              name="%S2 Salida Tostador"
              data={porcentajeS2ST.value}
              yAxis={1}
            />
            {/** -------------------------------- %SO2 Salida Tostador --------------------------------------- */}
            <Chart.Line
              name="%SO2 Salida Tostador"
              data={porcentajeS02ST.value}
              yAxis={1}
            />
            {/** -------------------------------- %As2S3 Salida Tostador --------------------------------------- */}
            <Chart.Line
              name="%As2S3 Salida Tostador"
              data={porcentajeAs2S3ST.value}
              yAxis={1}
            />
            {/** -------------------------------- %As4O6 Salida Tostador --------------------------------------- */}
            <Chart.Line
              name="%As4O6 Salida Tostador"
              data={porcentajeAs4O6ST.value}
              yAxis={1}
            />

            {/** -------------------------------- FECHAS --------------------------------------- */}
            <Chart.XAxis categories={flujosSolidosST.fecha} />

            <Chart.YAxis
              labelSuffix=" Nm3/h"
              title="Caudal de Gases, Nm3/h"
              lineWidth={2}
              lineColor="white"
              min={0}
              max={80000}
            />

            <Chart.YAxis
              labelSuffix=" %"
              title="Contenido, %"
              lineWidth={2}
              opposite={true}
              lineColor="white"
              min={0}
              max={80}
            />

            <Chart.Tooltip valueSuffix="" />
          </Chart>
        </Card.Content>
      </Card>
    </>
  );
}
